import { SettingsSearchProvider } from "../context/SettingsSearchContext";
import DashboardTopbar from "./DashboardTopbar";
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { SidebarInline } from './Dashboard';

const DashboardLayout = ({ children }) => {
  const pathname = useLocation().pathname;
  const fixedContentPage = ['/settings', '/user-management', '/templates', '/interviews'].includes(pathname) || /^\/templates\/(new|edit|clone)(?:\/|$)/.test(pathname) || /^\/interviews\/(new|edit)(?:\/|$)/.test(pathname);
  const [activeView, setActiveView] = useState('overview');
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });

  const sidebarWidth = isCollapsed ? '76px' : '236px';

  return (
    <SettingsSearchProvider>
    <div className="ttd-shell" style={{ display: 'flex', minHeight: '100dvh', height: fixedContentPage ? '100dvh' : undefined, overflow: fixedContentPage ? 'hidden' : undefined, overflowX: 'hidden' }}>
      <SidebarInline
        activeView={activeView}
        setActiveView={setActiveView}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          background: '#f8f6ff',
          minHeight: fixedContentPage ? 0 : '100vh',
          height: fixedContentPage ? { xs: 'calc(100dvh - 4rem)', md: '100dvh' } : undefined,
          overflowY: fixedContentPage ? 'hidden' : 'auto',
          marginLeft: { xs: 0, md: sidebarWidth },
          marginTop: { xs: '4rem', md: 0 },
          width: { xs: '100%', md: `calc(100% - ${sidebarWidth})` },
          transition: 'margin-left 0.3s ease-in-out, width 0.3s ease-in-out'
        }}
      >
        <DashboardTopbar />
        <Box sx={{ flex: 1, minHeight: 0, overflowY: fixedContentPage ? 'hidden' : undefined }}>
          {children}
        </Box>
      </Box>
    </div>
    </SettingsSearchProvider>
  );
};

export default DashboardLayout;
